import { Vue, Component, Watch } from "vue-property-decorator";
import { Tree, Icon, Button, Empty, Modal, List } from "ant-design-vue";
import Loading from "@/components/loading/loading.vue";
import { ContentObjectiveModule } from "@/modules/content-objective";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import { ITreeNode } from "@/services/objective-manager";
import { disabledDueToAccessLevel, getRouteAccessLevel, pureRichText } from "@/util/func";
import { AccessLevel } from "@/util/enum";
import { VNode } from "vue/types/umd";
import { fmtMsg } from "commonui";
import { VcsLocale } from "@/locales/localeid";

@Component({
	components: {
		Tree,
		Icon,
		Button,
		Loading,
		Empty,
		Modal,
		List
	}
})
export default class ContentObjective extends Vue {
	public showLine = true;
	public showIcon = true;
	public autoExpandParent = true;
	public cacheNodeId: string = "";
	public expandedKeys: string[] = [];
	public checkedKeys: string[] = [];
	public formatedTree: ITreeNode[] = [];
	public titleListModule = getModule(TitleListState);
	public isSaveDisabled: boolean = true;

	@Watch("titleListModule.editedContentDetails.vcsLevelId", { immediate: true, deep: true })
	async fetchContentObjectiveTree(value) {
		await ContentObjectiveModule.getContentObjectiveTree();
		this.updateTree();
	}

	@Watch("titleListModule.editeContentSelectedChapterId")
	updateTree() {
		this.checkedKeys = [];
		this.formatedTree = this.formatTreeLevel(ContentObjectiveModule.objectiveTree);
	}

	get ContentObjectiveModule() {
		return ContentObjectiveModule;
	}

	get objectiveTree() {
		return this.formatedTree;
	}

	get isLoading() {
		return ContentObjectiveModule.isLoading;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	onExpand(expandedKeys: []): void {
		this.expandedKeys = expandedKeys;
		this.autoExpandParent = false;
	}

	onCheck(keys) {
		this.isSaveDisabled = false;
		this.checkedKeys = keys;
	}

	onSelectNode(event: any): void {
		this.isSaveDisabled = false;
		const id = !event.length ? this.cacheNodeId : event[0];
		this.cacheNodeId = id;
		const index = this.checkedKeys.findIndex((key) => key == id);
		if (index > -1) {
			this.checkedKeys.splice(index, 1);
		} else {
			this.checkedKeys.push(id);
		}
	}

	displayWarningMessage(h: any) {
		return h("div", null, [
			h("div", null, [h("p", fmtMsg(VcsLocale.ContentObjectiveExposureWarning))]),
			h("div", null, [
				ContentObjectiveModule.objectiveList.length &&
					h("ul", null, [
						h(
							"li",
							null,
							ContentObjectiveModule.objectiveList.map((unit) =>
								h("li", { domProps: { innerHTML: unit } })
							)
						)
					])
			])
		]);
	}

	objectiveHasExposures() {
		Modal.warning({
			title: fmtMsg(VcsLocale.ContentObjectiveExposureTitle),
			content: this.displayWarningMessage,
			onOk: () => {}
		});
	}

	async onSubmit() {
		await ContentObjectiveModule.setObjectiveIds(this.checkedKeys);
		await ContentObjectiveModule.postContentObjectives();
		if (ContentObjectiveModule.objectiveHasExposure) {
			this.objectiveHasExposures();
			await ContentObjectiveModule.getContentObjectiveTree();
			await this.updateTree();
		}
		ContentObjectiveModule.setObjectiveHasExposure(false);
		this.isSaveDisabled = true;
	}

	formatTreeLevel(array) {
		const filteredArray = array.filter((o) => o.children.length > 0);
		const { editedContentId, editeContentSelectedChapterId } = this.titleListModule;

		// chapterId => "none" -> normal content, "all" -> parent content.
		const contentId =
			editeContentSelectedChapterId !== "none" && editeContentSelectedChapterId !== "all"
				? editeContentSelectedChapterId
				: editedContentId;
		return filteredArray.map((p) => {
			Object.assign(p, { key: p.id, title: p.text, checkable: false, scopedSlots: { title: "custom" } });
			if (p.children.length) {
				this.expandedKeys.push(p.key);
				p.children.forEach((child) => {
					if (child.contentObjective && child.contentObjective.length) {
						child.contentObjective
							.filter((o) => o.contentId == contentId)
							.forEach((o) => {
								this.checkedKeys.push(o.objectiveId);
							});
					}
					Object.assign(child, {
						key: child.id,
						title: child.text,
						text: pureRichText(child.text),
						checkable: true,
						scopedSlots: { title: "custom" }
					});
				});
			}
			return p;
		});
	}
}
